module.exports = __webpack_public_path__ + "assets/images/green-xmas-7.jpg?v=d5683260";